var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EmptyStateEntry',{attrs:{"title":_vm.$t('inspections.overdue-empty'),"text":_vm.$t('inspections.overdue-empty-description'),"image-src":"/images/empty-due.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }